import React from "react";
import PropTypes from "prop-types";
import * as FeatherIcon from "react-feather";

const getDomainName = (url) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
};

const DomainChip = ({ url }) => {
  const domain = getDomainName(url);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="badge bg-light text-dark d-inline-flex align-items-center text-decoration-none border"
      style={{
        // padding: "2px 2px",
        fontWeight: "500",
        backgroundColor: "#F7FBFF",
        borderRadius: "8px",
        fontSize: "11px",
        lineHeight: "11px",
        verticalAlign: "middle",
        textShadow: "none",
        // marginLeft: "5px",
        // marginBottom: "8px",
        marginBottom: "5px",
        minHeight: "9px",
        // maxHeight: "auto",
        whiteSpace: "normal",
        textAlign: "left",
      }}
    >
      {domain}
      <FeatherIcon.ArrowUpRight className="fa" style={{ width: 13 }} />
    </a>
  );
};

DomainChip.propTypes = {
  url: PropTypes.string.isRequired,
};

export default DomainChip;
